import { createAction } from 'redux-actions';

export const cancelGetHarvestPlans = createAction('CANCEL_GET_HARVEST_PLANS');
export const requestGetHarvestPlans = createAction('REQUEST_GET_HARVEST_PLANS');
export const receiveGetHarvestPlans = createAction('RECEIVE_GET_HARVEST_PLANS');
export const clearHarvestPlans = createAction('CLEAR_HARVEST_PLANS');
export const requestGetHarvestPlansList = createAction('REQUEST_GET_HARVEST_PLANS_LIST');
export const receiveGetHarvestPlansList = createAction('RECEIVE_GET_HARVEST_PLANS_LIST');
